<template>
  <o-view :has-white-background="true">
    <o-nav-bar title="S Mini" :has-back-button="true" />
    <o-section>
      <o-key-value label="Prijsklasse" value="S" />
      <o-key-value
        label="Omschrijving"
        value="Kleine stadwagens, voorzien van basisuitrusting."
        :full-width="true"
      />
    </o-section>
    <o-section>
      <o-key-value label="Voertuigtypes" />
      <o-cambio-car-type label="Ford Fiesta 5d/5p" />
      <o-cambio-car-type label="Citroën C3 5d/5p" />
    </o-section>
  </o-view>
</template>

<script>
import OKeyValue from '@/components/base/OKeyValue.vue'
import OCambioCarType from '@/components/OCambioCarType.vue'
export default {
  name: 'CambioClassIngo',
  components: { OKeyValue, OCambioCarType }
}
</script>

<style lang="scss"></style>
